import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";

const StudentExamResult = () => {
  const [getExamResult, setGetExamResult] = useState();
  const [fetchStatus, setFetchStatus] = useState(true);
  const [dataIndex, setDataIndex] = useState(5);
  const [hoveredRow, setHoveredRow] = useState(null);

  useEffect(() => {
    const fetchExamList = async () => {
      try {
        const res = await axiosInstance.get("/test/list");
        setGetExamResult(res.data.data.data);
      } catch (error) {
        console.error("Error fetching exam list:", error);
      } finally {
        setFetchStatus(false);
      }
    };

    fetchExamList();
  }, []);

  if (fetchStatus) {
    return (
      <div style={{ background: "white", borderRadius: "24px", padding: "28px", border: "1px solid rgba(226, 232, 240, 0.8)", display: "flex", justifyContent: "center" }}>
        <Loading />
      </div>
    );
  }

  if (!getExamResult || getExamResult.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        background: "white",
        borderRadius: "24px",
        padding: "28px",
        border: "1px solid rgba(226, 232, 240, 0.8)",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
        fontFamily: "'Outfit', sans-serif",
      }}
    >
      <div style={{ marginBottom: "20px" }}>
        <p
          style={{
            margin: "0 0 4px 0",
            fontSize: "18px",
            fontWeight: "800",
            color: "#0f172a",
          }}
        >
          Exam Results
        </p>
        <p style={{ margin: 0, fontSize: "13px", color: "#64748b", fontWeight: "500" }}>
          Your performance records for taken quizzes
        </p>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
          <thead>
            <tr style={{ borderBottom: "2px solid #f1f5f9" }}>
              <th style={{ padding: "12px 16px", fontSize: "13px", fontWeight: "700", color: "#64748b", textTransform: "uppercase" }}>Course Name</th>
              <th style={{ padding: "12px 16px", fontSize: "13px", fontWeight: "700", color: "#64748b", textTransform: "uppercase" }}>Quiz Name</th>
              <th style={{ padding: "12px 16px", fontSize: "13px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", textAlign: "center" }}>Type</th>
              <th style={{ padding: "12px 16px", fontSize: "13px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", textAlign: "center" }}>Attempts</th>
              <th style={{ padding: "12px 16px", fontSize: "13px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", textAlign: "center" }}>Result</th>
              <th style={{ padding: "12px 16px", fontSize: "13px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", textAlign: "right" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {getExamResult.slice(0, dataIndex).map((ele, idx) => {
              const totalAns = (ele.wrongAns || 0) + (ele.rightAns || 0);
              const scorePct = totalAns > 0 ? ((ele.rightAns || 0) / totalAns) * 100 : 0;
              const roundedScore = scorePct.toFixed(0);

              let scoreColor = "#dc2626";
              let scoreBg = "#fef2f2";
              if (scorePct >= 75) {
                scoreColor = "#059669";
                scoreBg = "#ecfdf5";
              } else if (scorePct >= 50) {
                scoreColor = "#d97706";
                scoreBg = "#fffbeb";
              }

              return (
                <tr
                  key={ele.id || idx}
                  onMouseEnter={() => setHoveredRow(idx)}
                  onMouseLeave={() => setHoveredRow(null)}
                  style={{
                    borderBottom: "1px solid #f1f5f9",
                    background: hoveredRow === idx ? "#f8fafc" : "transparent",
                    transition: "all 0.2s ease",
                  }}
                >
                  <td style={{ padding: "16px", fontSize: "14px", fontWeight: "700", color: "#0f172a" }}>
                    {ele.CourseName}
                  </td>
                  <td style={{ padding: "16px", fontSize: "14px", fontWeight: "600", color: "#475569" }}>
                    {ele.name}
                  </td>
                  <td style={{ padding: "16px", fontSize: "13px", color: "#94a3b8", fontWeight: "600", textAlign: "center" }}>
                    -
                  </td>
                  <td style={{ padding: "16px", fontSize: "13px", color: "#475569", fontWeight: "600", textAlign: "center" }}>
                    0
                  </td>
                  <td style={{ padding: "16px", textAlign: "center" }}>
                    <span
                      style={{
                        padding: "6px 12px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "700",
                        background: scoreBg,
                        color: scoreColor,
                        display: "inline-block",
                      }}
                    >
                      {roundedScore}%
                    </span>
                  </td>
                  <td style={{ padding: "16px", textAlign: "right" }}>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#4f46e5",
                        cursor: "pointer",
                      }}
                    >
                      Review →
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {getExamResult.length > 5 && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <button
            onClick={() => setDataIndex(dataIndex === 5 ? getExamResult.length : 5)}
            style={{
              padding: "8px 24px",
              borderRadius: "30px",
              border: "1px solid #cbd5e1",
              background: "white",
              color: "#475569",
              fontSize: "13px",
              fontWeight: "700",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
          >
            {dataIndex === 5 ? "View All Results" : "View Less"}
          </button>
        </div>
      )}
    </div>
  );
};

export default StudentExamResult;
